import { ErrorLabel } from '../InputField/BaseInputField';

const RadioButtonGroup = (props: any) => {
  return (
    <div>
      {props.children}
      <ErrorLabel name={props.name} />
    </div>
  );
};
export default RadioButtonGroup;
